import React, { useEffect } from 'react';
import { X } from 'lucide-react';

const Dialog = ({ open, onOpenChange, children, className }) => {
    useEffect(() => {
        if (open) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
            // Clean up any remaining styles just in case
            document.body.style.paddingRight = '0px';
        }
        return () => {
            document.body.style.overflow = 'unset';
            document.body.style.paddingRight = '0px';
        };
    }, [open]);

    if (!open) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div
                className="fixed inset-0 bg-black/50 transition-opacity"
                onClick={() => onOpenChange(false)}
            />
            <div className={`relative z-50 w-full animate-in fade-in zoom-in duration-200 ${className || 'max-w-lg'}`}>
                {children}
            </div>
        </div>
    );
};

const DialogContent = ({ children, className = '' }) => (
    <div className={`bg-white rounded-xl shadow-2xl p-3 overflow-hidden ${className}`}>
        {children}
    </div>
);

const DialogHeader = ({ children, className = '' }) => (
    <div className={`py-2 ${className}`}>
        {children}
    </div>
);

const DialogTitle = ({ children, className = '' }) => (
    <h2 className={`text-xl font-semibold text-primary-text ${className}`}>
        {children}
    </h2>
);

const DialogFooter = ({ children, className = '' }) => (
    <div className={`p-6 pt-2 flex justify-end gap-3 bg-gray-bg/30 ${className}`}>
        {children}
    </div>
);

export { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter };
